import React from 'react';

const NoPayment = () =>
  <div>
    <h1>El servicio no se encuentra disponible.</h1>
  </div>

export default NoPayment;
